import { AppTreeSide, UniDateRangePicker } from 'components'
import validatorMixin from '@/mixins/validator-mixin.js' // 引入mixin文件
import ssoLoginMixin from '@/mixins/sso-login-mixin.js' // 引入mixin文件
import idNameMixin from '@/mixins/id-name-mixin.js' // 引入mixin文件
import convertorMixin from '@/mixins/convertor-mixin.js' // 引入mixin文件
import typeImageMixin from '@/mixins/type-image-mixin.js' // 引入mixin文件
import {getRegionList} from '@/api/get-data.js'
import {download} from '@/utils/download'
import {loadRegionTree, loadStreamNodeTreeItems} from '@/utils/tree'
import {getTodayBeginAndEndDate} from '@/utils/date'

export default {
  name: 'RecordRecord',
  data() {
    return {
      // 侧边栏打开标志
      treeSideBarOpen: true,
      // 树数据
      treeData: [],
      // 树节点已加载的区域id数组
      treeNodeLoadedRegionIds: [],
      treeExpandedKeys: [], // 默认展开树节点key
      // 默认树属性
      defaultTreeProps: {
        label: 'name' // name字段作为label
      },
      // 树节点显示过滤
      treeNodeFilter: '',
      filteredTreeData: [],
      // 查询条件
      treeQueryParams: {
        pageNum: 1,
        pageSize: 1000
      },
      // 表格数据
      tableData: [],
      tableTotalRow: 0,
      // 遮罩层
      loading: false,
      dates: [], // 查询起始和结束日期
      tableQueryParams: {
        regionId: -1,
        nodeId: 0,
        descendantRegionRequired: 1,
        recordFileType: 0,
        recordFileEventType: 0,
        recordBeginDateTime: 0,
        recordEndDateTime: 0,
        pageNum: 1,
        pageSize: 15
      },
      // 表格选中记录数组
      tableSelectedIds: [],
      tableSelectedUrls: [],
      // 加锁/解锁参数
      lockParams: {
        recordRecordIds: [],
        lockDuration: 0,
        locked: 0
      },
      // 记录编辑
      modalOpen: false,
      modalForm: {
        id: undefined,
        name: undefined,
        localPath: undefined,
        virtualPath: undefined,
        serverId: undefined,
        totalSize: undefined,
        availableSize: undefined,
        usedSize: undefined,
        reservedSize: 0.0
      },
      // 表单校验
      formRules: {
        name: [
          {required: true, message: '录像空间名称不能为空', trigger: 'blur'}
        ],
        localPath: [
          {required: true, message: '本地路径不能为空', trigger: 'blur'}
        ],
        virtualPath: [
          {required: true, message: '虚拟路径不能为空', trigger: 'blur'}
        ],
        serverId: [
          {required: true, message: '服务器不能为空', trigger: 'blur'}
        ],
        reservedSize: [
          {required: true, validator: this.validateFloat, trigger: 'blur'}
        ]
      },
      // 数据导入
      upload: {
        // 是否显示数据导入弹出层
        open: false,
        // 弹出层标题（数据导入）
        title: '数据导入',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的记录数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: '',
        // 上传的地址
        url: '/api/recordRecord/import'
      }
    }
  },
  components: {
    AppTreeSide,
    UniDateRangePicker
  },
  mixins: [
    validatorMixin,
    ssoLoginMixin,
    idNameMixin,
    convertorMixin,
    typeImageMixin
  ],
  watch: {
    // 根据名称筛选节点
    treeNodeFilter(val) {
      this.$refs.tree.filter(val.trim())
    }
  },
  mounted() {
    // 设置查询起始日期和截止日期
    this.dates = getTodayBeginAndEndDate()

    // 单点登录（如url包含code和uiapTpye参数则启用单点登录）
    this.ssoLogin(this.$route.query.code, this.$route.query.uiapType).then(res => {
      // 获取区域列表
      this.getRegionList2()
    })
  },
  methods: {
    // 显示或隐藏树侧边栏
    toggleTreeSideBar() {
      this.treeSideBarOpen = !this.treeSideBarOpen
    },
    // 查询区域列表
    getRegionList2() {
      this.loading = true
      getRegionList(this.$globalConfig.regionGettingFilterMode, () => {
        this.loading = false
        this.treeData = []
        this.treeData = loadRegionTree(this.$globalData.regions, this.treeData)
        this.$nextTick(() => {
          if (this.treeData.length) {
            // 默认展开根节点
            this.treeExpandedKeys = [this.treeData[0].key]
            // 设置根节点为当前节点
            this.$refs.tree.setCurrentKey(this.treeData[0].key)
            // 单击当前节点
            this.handleTreeNodeClick(this.$refs.tree.getCurrentNode())
          }
        })
      })
    },
    // 查询视频节点列表
    getStreamNodeList(regionId) {
      // 检测该区域下视频节点是否已加载，防止重复加载
      if (this.treeNodeLoadedRegionIds.indexOf(regionId) !== -1) {
        return
      }

      this.loading = true
      this.$http(this.$api.streamNodeList, {
        regionId: regionId,
        pageNum: 1,
        pageSize: 1000
      }).then(
        res => {
          if (res.code === 200) {
            if (res.data.length) {
              this.treeData = loadStreamNodeTreeItems(res.data, this.treeData)
              if (this.$refs.tree.currentNode && this.treeExpandedKeys.indexOf(this.$refs.tree.currentNode.node.key) === -1) {
                this.treeExpandedKeys.push(this.$refs.tree.currentNode.node.key) // 展开父区域
              }
            }
            this.treeNodeLoadedRegionIds.push(regionId)
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 查询录像记录列表
    getRecordRecordList() {
      this.loading = true
      this.tableQueryParams.descendantRegionRequired = this.tableQueryParams.nodeId === 0 ? 1 : 0 // 指定节点id后不需要查询子区域
      this.tableQueryParams.recordBeginDateTime = this.dates[0].getTime() / 1000
      this.tableQueryParams.recordEndDateTime = this.dates[1].getTime() / 1000
      this.$http(this.$api.recordRecordList, this.tableQueryParams).then(
        res => {
          if (res.code === 200) {
            this.tableData = res.data
            this.tableTotalRow = res.page.totalRow
          }
          this.loading = false
        }
      ).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    // 过滤树节点
    filterTreeNode(value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    // 单击树节点
    handleTreeNodeClick(obj) {
      if (obj.type === 'region' && this.tableQueryParams.regionId !== obj.id) {
        this.tableQueryParams.regionId = obj.id
        this.tableQueryParams.nodeId = 0
        this.getStreamNodeList(obj.id)
        this.getRecordRecordList()
      } else if (obj.type === 'streamNode' && this.tableQueryParams.nodeId !== obj.id) {
        this.tableQueryParams.regionId = obj.regionId
        this.tableQueryParams.nodeId = obj.id
        this.tableQueryParams.pageNum = 1
        this.getRecordRecordList()
      }
    },
    // 查询按钮操作
    handleFormQuery() {
      this.tableQueryParams.page = 1
      this.getRecordRecordList()
    },
    // 重置按钮操作
    resetQueryForm() {
      this.tableQueryParams.regionId = 0
      this.tableQueryParams.nodeId = 0
      this.tableQueryParams.descendantRegionRequired = 1
      this.tableQueryParams.recordFileType = 0
      this.tableQueryParams.recordFileEventType = 0
      this.tableQueryParams.recordBeginDateTime = 0
      this.tableQueryParams.recordEndDateTime = 0
      this.dates = getTodayBeginAndEndDate()
      this.$refs['queryForm'].resetFields()
      this.handleFormQuery()
    },
    // 分页
    handleCurrentPageChange(val) {
      this.tableQueryParams.pageNum = val
      this.getRecordRecordList()
    },
    // 页面条数改变
    handlePageSizeChange(val) {
      this.tableQueryParams.pageSize = val
      this.getRecordRecordList()
    },
    // 表格选中记录改变
    handleTableSelectionChange(selection) {
      this.tableSelectedIds = selection.map(item => item.id)
      this.tableSelectedUrls = selection.map(item => item.url)
    },
    // 锁定
    handleLock(row, value) {
      this.$messagebox.confirm(value === 1 ? '您确定锁定选中的文件吗?' : '您确定解锁选中的文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (row && row.id) {
          this.lockParams.recordRecordIds = []
          this.lockParams.recordRecordIds.push(row.id)
          this.lockParams.locked = value
        } else {
          this.lockParams.recordRecordIds = this.tableSelectedIds
          this.lockParams.locked = value
        }
        this.$http(this.$api.lockRecordRecord, this.lockParams).then(
          res => {
            if (res.code === 200) {
              this.tableQueryParams.pageNum = 1
              this.getRecordRecordList()
              this.$message({
                type: 'success',
                message: '操作成功!'
              })
            }
          }
        )
      })
    },
    // 下载文件
    handleDownload(row) {
      if (row && row.id) {
        if (!row.url) {
          this.$message({type: 'warning', message: '无效文件url!'})
          return
        }
        download(row.url)
      } else if (this.tableSelectedUrls.length > 0) {
        this.$messagebox.confirm('您确定下载选中的' + this.tableSelectedUrls.length + '个文件吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.tableSelectedUrls.forEach(item => {
            if (item) {
              download(item)
            }
          })
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/system/recordRecord/RecordRecord.js